import {ColorType, TextType} from '@/Styles/types';
import React, {ReactNode} from 'react';
import {Component} from './text.styled';
import {memo} from 'react';
import {Div} from '@/Website/Components/UI';
export interface TextProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  type?: TextType;
  color?: ColorType;
  fontWeight?: 400 | 600 | 800;
  italic?: boolean;
  textAlign?: 'center' | 'left' | 'right';
  flex?: string;
  lineThrough?: boolean;
  flexBasis?: string;
  noWrap?: boolean;
  cursor?: 'pointer';
  isLoading?: boolean;
  loadingWidth?: number;
  wordBreak?: 'break-all';
}

const Text: React.FC<TextProps> = props => {
  const {children, isLoading, loadingWidth, ...restProps} = props;

  return (
    //@ts-ignore
    <Component className="Text" {...restProps}>
      {isLoading ? <Div className="text-loader" width={loadingWidth || 50} /> : children}
    </Component>
  );
};

export default memo(Text);
